import { X } from 'lucide-react'
import type { ReactNode } from 'react'

interface Props {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
}

/**
 * Lightweight modal used by the filing wizards to surface the taxpayer / company
 * reference details on demand, so the main content can use the full page width.
 */
export default function WizardDetailsModal({ open, onClose, title = 'Details', children }: Props) {
  if (!open) return null

  return (
    <div
      className='fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 p-4 sm:items-center'
      onClick={onClose}
      role='dialog'
      aria-modal='true'
    >
      <div
        className='w-full max-w-md rounded-2xl bg-white p-6 shadow-xl'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='mb-4 flex items-center justify-between'>
          <h2 className='text-lg font-bold text-gray-900'>{title}</h2>
          <button
            type='button'
            onClick={onClose}
            aria-label='Close'
            className='rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition'
          >
            <X className='h-5 w-5' />
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}
